import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IFlagCollectionTriageClipRequest } from './flag-collection-triage-clip-request';
import type { IFlagCollectionTriageClipResponse } from './flag-collection-triage-clip-response';
import { flagCollectionTriageClipResponseSchema } from './flag-collection-triage-clip-response';

export async function flagCollectionTriageClipApi({
  collectionId,
  clipId,
}: IFlagCollectionTriageClipRequest): Promise<
  IValidatedResponse<IFlagCollectionTriageClipResponse>
> {
  return postRequest<IFlagCollectionTriageClipResponse>({
    path: `/sys/collections/${collectionId}/triage/clips/${clipId}/flag/v1`,
    body: {},
    schema: flagCollectionTriageClipResponseSchema,
  });
}
